import moment from 'moment'
import source from './source'

const item = index => ({
    id: index,
    name: `Funds of France ${index}`,
    type: 'x',
    status: (index % 2 === 0 ? 'completed' : 'pending_review'),
    numErrors: !index ? 230 : 0,
    numWarnings: !index ? 0 : 0,
    numAddedRows: !index ? 230 : 3,
    numUpdatedCells: 230,
    createdAt: moment(new Date()).add(index, 'days'),
    updatedAt: moment(new Date()).add(index + 1, 'days'),
})

const imports = {
    data: Array.from({ length: 5 }, (i, index) => item(index)),
}

export default {
    imports,
    source,
}
